module.exports = __webpack_public_path__ + "static/media/laurel_score.0aa0eca7.svg";